var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVisaLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 11,
    viewBox: "0 0 33 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.42621 10.0739H5.59999L3.48066 2.21127C3.38007 1.84959 3.16649 1.52985 2.85231 1.37915C2.06824 1.00043 1.20425 0.69903 0.261719 0.547019V0.244308H4.81454C5.4429 0.244308 5.91417 0.69903 5.99271 1.22714L7.09233 6.8987L9.91718 0.244308H12.6649L8.42621 10.0739ZM14.2358 10.0739H11.5666L13.7645 0.244308H16.4336L14.2358 10.0739ZM19.8868 2.96737C19.9654 2.43795 20.4366 2.13524 20.9865 2.13524C21.8504 2.05924 22.7916 2.21125 23.577 2.58865L24.0483 0.472299C23.2629 0.169589 22.3989 0.0175781 21.6148 0.0175781C19.0242 0.0175781 17.1391 1.37912 17.1391 3.26877C17.1391 4.70632 18.4744 5.46113 19.4169 5.91585C20.4366 6.36926 20.8294 6.67197 20.7508 7.12538C20.7508 7.8055 19.9654 8.10821 19.1813 8.10821C18.2388 8.10821 17.2962 7.8815 16.4336 7.50279L15.9624 9.62045C16.9049 9.99786 17.9246 10.1499 18.8671 10.1499C21.7719 10.2246 23.577 8.86433 23.577 6.82267C23.577 4.2516 19.8868 4.1009 19.8868 2.96737ZM32.9183 10.0739L30.799 0.244308H28.5226C28.0513 0.244308 27.5801 0.547019 27.423 1.00043L23.4985 10.0739H26.2462L26.7946 8.63765H30.1707L30.4848 10.0739H32.9183ZM28.9153 2.8914L29.6994 6.596H27.5015L28.9153 2.8914Z",
    fill: "#172B85"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisaLogo);
export default __webpack_public_path__ + "static/media/visaLogo.16b5b6d6087cf0898c5544ffe2cb634e.svg";
export { ForwardRef as ReactComponent };